import { QUERY_PARAMS } from './constants';

function buildURLWithParams(path, params, flow) {
  return params ? `${flow}&redirect=${path}&${QUERY_PARAMS.CABINET}=${params}` : flow;
}

export { buildURLWithParams };